const e = {
  modelValue: [String, Number, Boolean, Object],
  label: {
    type: String
  },
  size: {
    type: String
  },
  valueKey: String,
  disabled: Boolean
}, t = Symbol("selectContext");
export {
  t as selectContextKey,
  e as selectProps
};
